import React, {Component} from 'react';
import {Button, Radio, message, Input, Modal, Icon} from 'antd';
import {Redirect} from 'react-router';
import utils from '../../../utils/common';
import './style.less';

const {TextArea} = Input;
class CheckDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      files: [],
      invoiceTypeData: ['不开发票', '增值税普票-纸制', '增值税普票-电子', '增值税专票'],
      firstStatusData: ['审核中', '审核通过', '审核不通过'],
      secondStatusData: ['审核中', '审核通过', '审核不通过'],
      status: ['审核中', '审核不通过', '充值中', '充值失败', '充值成功'],
      secondStatus: 1,
      checkRmk: '',
      form: {
        id: '',
        gmt_created: '',
        agent_no: '',
        agent_name: '',
        recharge_no: '',
        recharge_amt: '',
        recharge_type: '',
        invoice_type: '',
        first_check_status: '',
        first_check_name: '',
        gmt_first_check: '',
        second_check_name: '',
        second_check_status: '',
        first_check_rmk: '',
        invoice_name: '',
        invoice_tax_no: '',
        bank_name: '',
        email_address: '',
        recipient_phone: '',
        recipient_address: ''
      },
      isShowImg: false, // 显示图片原图
      picUrl: '' // 图片链接地址
    };
  }
  componentWillMount() {
    this.initForm();
  }
  initForm = () => {
    const id = this.props.location.state.id;
    if (!this.props.location.state.id) return false;
    window.api('eps.recharge.getinfo', {recharge_id: id}).then(rs => {
      const form = Object.assign(rs.recharge, rs.recharge_invoice);
      this.setState({form, files: rs.files});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }
  goBackEvent = () => {
    window.history.go(-1);
  }
  selectEvent = (type, e) => {
    let obj = {};
    switch (type) {
      case 'checkStatus':
        obj = {secondStatus: e.target.value};
        break;
      case 'checkRmk':
        obj = {checkRmk: e.target.value};
        break;
      default:
        break;
    }
    this.setState(obj);
  }
  checkEvent = (type) => {
    const {form, secondStatus, checkRmk} = this.state;
    let chktype = 1;
    if (Number(type) === 2) { //初审状态不是审核通过
      chktype = 2;
    }
    let params = {
      recharge_id: form.id,
      checkType: String(chktype), //判断是初审还是复审
      checkStatus: String(secondStatus), //充值类型
      checkRmk: checkRmk.split(/[(\r\n)\r\n]+/).join('') //发票类型
    };
    params = utils.dealElement(params);
    window.api('eps.rechagre.check', params).then(rs => {
      message.success(rs.service_error_message);
      this.props.history.push({pathname: '/main/topuplist'});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }
  showImg = (value, url) => {
    this.setState({isShowImg: value, picUrl: url});
  }
  render() {
    const {
      redirect,
      form,
      status,
      invoiceTypeData,
      firstStatusData,
      secondStatusData,
      secondStatus,
      files,
      picUrl,
      isShowImg,
      checkRmk
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    const isSecondCheck = Number(form.first_check_status) === 2;
    return (
      <div className="topup-blocks topup-check-page">
        <Modal
          title={false}
          footer={false}
          onCancel={this.showImg.bind(this, false, '')}
          visible={isShowImg}
          width={580}
          wrapClassName="detail-img-modal"
        >
          <img src={picUrl} alt="" style={{width: '100%', display: 'block'}} />
        </Modal>
        <div className="detail-header">
          {/* <Button type="primary" onClick={this.goBackEvent.bind(this)}>
            <Icon type="left" /> 返回
          </Button> */}
          <div className="detail-header-text">
            <h1 className="detail-page-title">充值审核</h1>
            <p className="detail-page-desc">{isSecondCheck ? '复审' : '初审'}充值单</p>
          </div>
        </div>
        <div className="detail-card">
          <h2 className="detail-section-title">充值详情</h2>
          <dl className="detail-items detail-section-body">
            <dd>
              <div className="detail-row"><span className="detail-label">创建日期</span><span className="detail-value">{form.gmt_created}</span></div>
              <div className="detail-row"><span className="detail-label">代理商ID/名称</span><span className="detail-value">{form.agent_no} / {form.agent_name}</span></div>
              <div className="detail-row"><span className="detail-label">充值单号</span><span className="detail-value">{form.recharge_no}</span></div>
              <div className="detail-row"><span className="detail-label">充值金额</span><span className="detail-value">{form.recharge_amt}</span></div>
              <div className="detail-row"><span className="detail-label">充值方式</span><span className="detail-value">{Number(form.recharge_type) === 1 ? '返佣账号充值' : '线下转账'}</span></div>
              <div className="detail-row"><span className="detail-label">是否开票</span><span className="detail-value">{Number(form.invoice_type) !== 0 ? '是' : '否'}</span></div>
              <div className="detail-row"><span className="detail-label">发票类型</span><span className="detail-value">{invoiceTypeData[Number(form.invoice_type)]}</span></div>
              {files && files.length > 0 && (
                <div className="detail-row detail-row-full">
                  <span className="detail-label">打款截图</span>
                  <div className="detail-screenshots">
                    {files.map((item, index) => (
                      <div className="imgBox" key={index}>
                        <div onClick={this.showImg.bind(this, true, item)}>查看</div>
                        <img src={item} alt="" className="files" />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {Number(form.invoice_type) !== 0 && <div className="detail-row"><span className="detail-label">名称</span><span className="detail-value">{form.invoice_name}</span></div>}
              {Number(form.invoice_type) === 2 && <div className="detail-row"><span className="detail-label">邮箱</span><span className="detail-value">{form.email_address}</span></div>}
              {Number(form.invoice_type) !== 0 && <div className="detail-row detail-row-full"><span className="detail-label">税号</span><span className="detail-value">{form.invoice_tax_no}</span></div>}
              {Number(form.invoice_type) === 1 && form.recipient_address && <div className="detail-row detail-row-full"><span className="detail-label">发票寄回地址</span><span className="detail-value">{form.recipient_address.split('=').slice(0, 3).join(' ')}</span></div>}
              {Number(form.invoice_type) === 1 && form.recipient_address && <div className="detail-row detail-row-full"><span className="detail-label">详细地址</span><span className="detail-value">{form.recipient_address.split('=')[3]}</span></div>}
              {Number(form.invoice_type) === 1 && <div className="detail-row"><span className="detail-label">收件人</span><span className="detail-value">{form.recipient_name}</span></div>}
              {Number(form.invoice_type) === 1 && <div className="detail-row"><span className="detail-label">手机号</span><span className="detail-value">{form.recipient_phone}</span></div>}
              {Number(form.invoice_type) === 3 && form.bank_account_no && <div className="detail-row detail-row-full"><span className="detail-label">银行账户</span><span className="detail-value">{form.bank_account_no}</span></div>}
              {Number(form.invoice_type) === 3 && form.bank_name && <div className="detail-row detail-row-full"><span className="detail-label">开户支行</span><span className="detail-value">{form.bank_name}</span></div>}
              {Number(form.invoice_type) === 3 && form.company_address && <div className="detail-row detail-row-full"><span className="detail-label">单位所在地区</span><span className="detail-value">{form.company_address.split('=').slice(0, 3).join(' ')}</span></div>}
              {Number(form.invoice_type) === 3 && form.company_address && <div className="detail-row detail-row-full"><span className="detail-label">单位详细地址</span><span className="detail-value">{form.company_address.split('=')[3]}</span></div>}
              {Number(form.invoice_type) === 3 && <div className="detail-row detail-row-full"><span className="detail-label">电话号码</span><span className="detail-value">{form.company_phone}</span></div>}
              {Number(form.invoice_type) === 3 && form.recipient_address && <div className="detail-row detail-row-full"><span className="detail-label">发票寄回地址</span><span className="detail-value">{form.recipient_address.split('=').join(' ')}</span></div>}
              {Number(form.invoice_type) === 3 && <div className="detail-row"><span className="detail-label">收件人</span><span className="detail-value">{form.recipient_name}</span></div>}
              {Number(form.invoice_type) === 3 && <div className="detail-row"><span className="detail-label">手机号</span><span className="detail-value">{form.recipient_phone}</span></div>}
            </dd>
          </dl>
        </div>
        <div className="detail-card">
          <h2 className="detail-section-title">审核信息</h2>
          <dl className="detail-items detail-section-body">
            <dd>
              {isSecondCheck && (
                <div>
                  <div className="detail-row"><span className="detail-label">初审状态</span><span className="detail-value">{form.first_check_status != null ? firstStatusData[Number(form.first_check_status) - 1] : '--'}</span></div>
                  <div className="detail-row"><span className="detail-label">审核时间</span><span className="detail-value">{form.gmt_first_check || '--'}</span></div>
                  <div className="detail-row detail-row-full"><span className="detail-label">审核人</span><span className="detail-value">{form.first_check_name || '--'}</span></div>
                  <div className="detail-row detail-row-full"><span className="detail-label">审核意见</span><span className="detail-value">{form.first_check_rmk || '--'}</span></div>
                </div>
              )}
              {isSecondCheck && form.second_check_status != null && (
                <div className="detail-sub-section">
                  <div className="detail-row"><span className="detail-label">复审状态</span><span className="detail-value">{secondStatusData[Number(form.second_check_status) - 1]}</span></div>
                  <div className="detail-row"><span className="detail-label">审核时间</span><span className="detail-value">{form.gmt_second_check || '--'}</span></div>
                  <div className="detail-row detail-row-full"><span className="detail-label">审核人</span><span className="detail-value">{form.second_check_name || '--'}</span></div>
                  <div className="detail-row detail-row-full"><span className="detail-label">审核意见</span><span className="detail-value">{form.second_check_rmk || '--'}</span></div>
                </div>
              )}
            </dd>
          </dl>
        </div>
        <div className="detail-card check-form-card">
          <h2 className="detail-section-title">{isSecondCheck ? '复审审核' : '初审审核'}</h2>
          <div className="check-form-body">
            <div className="check-form-row">
              <span className="check-form-label">审核结果</span>
              <Radio.Group onChange={this.selectEvent.bind(this, 'checkStatus')} value={secondStatus} className="check-radio-group">
                <Radio value={1}>通过</Radio>
                <Radio value={2}>不通过</Radio>
              </Radio.Group>
            </div>
            <div className="check-form-row check-form-row-full">
              <span className="check-form-label">备注</span>
              <TextArea
                rows={4}
                placeholder="请输入审核备注（选填）"
                value={checkRmk}
                onChange={this.selectEvent.bind(this, 'checkRmk')}
                className="check-textarea"
              />
            </div>
          </div>
        </div>
        <div className="detail-actions check-actions">
          <Button type="primary" className="btn-submit" onClick={this.checkEvent.bind(this, form.first_check_status)}>提交审核</Button>
          <Button className="btn-cancel" onClick={this.goBackEvent.bind(this)}>关闭</Button>
        </div>
      </div>
    );
  }
}
export default CheckDetail;



// WEBPACK FOOTER //
// ./src/containers/backEnd/topupMangement/check.jsx